import { createBrowserRouter } from 'react-router-dom';

import NotFoundComponent from '@/common/components/404';
import { links } from '@/common/utils/links';
import { LoginLayout } from '@/layouts/Login';
import { ClientsRoutes } from '@/modules/clients';
import { ContractsRoutes } from '@/modules/contract';
import { DealersRoutes } from '@/modules/dealers';
import { InvoicesRoutes } from '@/modules/invoices';
import { InvoicingRoutes } from '@/modules/invoicing';
import { InvoicingPublicRoutes } from '@/modules/invoicing/routes/public.routes';
import ActivateUser from '@/modules/login/pages/ActivateUser';
import ForgotPassword from '@/modules/login/pages/ForgotPassword';
import ResetPassword from '@/modules/login/pages/ResetPassword';
import Sso from '@/modules/login/pages/Sso';
import { PanelRoutes } from '@/modules/panel';
import { PricerRoutes } from '@/modules/pricer';
import { QuotesRoutes } from '@/modules/quotes';
import { ReportsRoutes } from '@/modules/reports';
import { SettingsRoutes } from '@/modules/settings';
import { StoresRoutes } from '@/modules/stores';
import { UserProfileRoutes } from '@/modules/userProfile';

export const ProtectedRoutes = createBrowserRouter([
  ...PanelRoutes,
  ...ContractsRoutes,
  ...ClientsRoutes,
  ...DealersRoutes,
  ...StoresRoutes,
  ...QuotesRoutes,
  ...ReportsRoutes,
  ...InvoicingRoutes,
  ...PricerRoutes,
  ...InvoicesRoutes,
  ...UserProfileRoutes,
  ...SettingsRoutes,
  ...InvoicingPublicRoutes,
  {
    element: <LoginLayout />,
    children: [
      {
        path: links.login.forgotPassword,
        element: <ForgotPassword />,
      },
      {
        path: links.login.resetPassword,
        element: <ResetPassword />,
      },
      {
        path: links.login.activateUser,
        element: <ActivateUser />,
      },
      {
        path: links.login.sso,
        element: <Sso />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundComponent />,
  },
]);
